module.exports = __webpack_public_path__ + "img/logo.d9453572.png";